exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\r\n    position: relative;\r\n    padding: 1px !IMPORTANT;\r\n    margin-bottom: 0px !IMPORTANT;\r\n    border: 1px solid transparent !IMPORTANT;\r\n    border-radius: 1px !IMPORTANT;\r\n    color:#960018;\r\n}\r\n.form-group {\r\n    margin-bottom: 1rem !important;\r\n    height: 68px !important;\r\n}\r\nimg {\r\n    vertical-align: middle;\r\n    border-style: none;\r\n    /* margin-left: -1%; */\r\n    margin-top: 6%;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/new-user-by-bank/new-user-by-bank.component.css
// module id = ../../../../../src/app/new-user-by-bank/new-user-by-bank.component.css
// module chunks = main